import {compress, decompress} from 'lz-string';
import moment from "moment";

export default class LocalStorageService {
  
    // Initializing important variables
    /*
    constructor() {
        this.configService = new ConfigService();
        this.useCompression = this.configService.getValue("localcompression");
    }
    */

    setKey(key, val){
        var storedKey = (this.useCompression) ? compress(key): key;
        var storedVal = (this.useCompression) ? compress(val): val;
        localStorage.setItem(storedKey, storedVal);
    }

    getKey(key){
        let storedKey = (this.useCompression) ? decompress(key): key;
        let val = localStorage.getItem(storedKey);
        let storedVal = (this.useCompression) ? decompress(val): val;
        return storedVal;
    }

    keyExists(key){
        let storedKey = (this.useCompression) ? decompress(key): key;
        return (this.getKey(storedKey)!=null);
    }

    removeKey(key){
        let storedKey = (this.useCompression) ? decompress(key): key;
        localStorage.removeItem(storedKey);    
    }



    saveSingleVal(key, val, shouldCompress=false)
    {
        let storedVal = (shouldCompress) ? compress(val) : val;
        localStorage.setItem(key, storedVal);
    }

    getSingleVal(key, shouldDecompress=false)
    {
        var item = localStorage.getItem(key);
        return (shouldDecompress) ? decompress(item) : item;
    }

    saveObjectVal(key, obj, shouldCompress=false)
    {
        let storedObj = (shouldCompress) ? compress(JSON.stringify(obj)) : JSON.stringify(obj);
        localStorage.setItem(key, storedObj);
    }

    getObjectVal(key, shouldDecompress=false)
    {
        let storedObj = localStorage.getItem(key);
        var result = (shouldDecompress) ? JSON.parse(decompress(storedObj)) : JSON.parse(storedObj);
        return result;
    }

    hasKey(key)
    {
        return (localStorage.getItem(key)!=null);
    }


    toUserKey(gcid, uid, keyTypeId="")
    {
        return "msa~" + gcid + "~" + uid +
            (keyTypeId !== "") ? "~" + keyTypeId.toLowerCase().trim(): "";
    }

  

    hasLastUserSession()
    {
        const KEYTYPEID = "msa~lastusersession";
        return (this.hasKey(KEYTYPEID));
    }

    getLastUserSession()
    {
        const KEYTYPEID = "msa~lastusersession";
        return (this.hasKey(KEYTYPEID)) ? this.getObjectVal(KEYTYPEID, false) : {isValid: false};
    }

    saveLastUserSession(userSession)
    {
        const KEYTYPEID = "msa~lastusersession";
        this.saveObjectVal(KEYTYPEID, userSession, false);
    }

    removeLastUserSession(userSession)
    {
        const KEYTYPEID = "msa~lastusersession";
        this.removeKey(KEYTYPEID);
    }

    hasLastUserInfo()
    {
        const KEYTYPEID = "msa~lastuserinfo";
        return (this.hasKey(KEYTYPEID));
    }

    getLastUserInfo()
    {
        const KEYTYPEID = "msa~lastuserinfo";
        return (this.hasKey(KEYTYPEID)) ? this.getObjectVal(KEYTYPEID, false) : {isValid: false};
    }

    saveLastUserInfo(userInfo)
    {
        const KEYTYPEID = "msa~lastuserinfo";
        this.saveObjectVal(KEYTYPEID, {"gcid": userInfo.gcid, "uid": userInfo.uid, "lastlocationid": userInfo.currentLocationId, "locationinfo": userInfo.locationInfo}, false);
    }



    saveLocalAddressBook(gcid, userId, addressBook)
    {
        const KEYTYPEID = "msa~" + gcid + "~" + userId + "~addressbook";
        this.saveObjectVal(KEYTYPEID, addressBook, true);
        //localStorage.setItem("addressbook-" + gcid + '-' + userId, compress(JSON.stringify(addressBook)));  
    }

    hasLocalAddressBook(gcid, userId)
    {
        const KEYTYPEID = "msa~"+ gcid + "~" + userId + "~addressbook";
        return (this.hasKey(KEYTYPEID));
        //return this.keyExists("addressbook-" + gcid + '-' + userId);
    }

    getLocalAddressBook(gcid, userId)
    {
        const KEYTYPEID = "msa~" + gcid + "~" + userId + "~addressbook";
        return this.getObjectVal(KEYTYPEID, true);
        //return JSON.parse(decompress(localStorage.getItem("addressbook-" + gcid + '-' + userId)));
    }

    saveLastReceiptLine(gcid, receiptLine)
    {
        const KEYTYPEID = "msa~" + gcid + "~lastreceiptline";
        this.saveObjectVal(KEYTYPEID, receiptLine, false);
    }

    hasLastReceiptLine(gcid)
    {
        const KEYTYPEID = "msa~" + gcid + "~lastreceiptline";
        return (this.hasKey(KEYTYPEID));
    }

    getLastReceiptLine(gcid)
    {
        const KEYTYPEID = "msa~" + gcid + "~lastreceiptline";
        return this.getObjectVal(KEYTYPEID, false);
    }

    hasHistoryGridLayout(gcid, uid)
    {
        const KEYTYPEID = "msa~" + gcid + "~" + uid + "~historygridLayout";
        return this.hasKey(KEYTYPEID);
    }

    saveHistoryGridLayout(gcid, uid, gridLayout)
    {
        const KEYTYPEID = "msa~" + gcid + "~" + uid + "~historygridLayout";
        return this.saveObjectVal(KEYTYPEID, gridLayout, false);  
    }

    getHistoryGridLayout(gcid, uid)
    {
        const KEYTYPEID = "msa~" + gcid + "~" + uid + "~historygridLayout";
        return this.getObjectVal(KEYTYPEID, false);
    }

    hasAppInfo(gcid, uid)
    {
        const KEYTYPEID = "msa~" + gcid + "~" + uid + "~appinfo";
        return this.hasKey(KEYTYPEID);
    }

    saveAppInfo(gcid, uid, appInfo)
    {
        const KEYTYPEID = "msa~" + gcid + "~" + uid + "~appinfo";
        return this.saveObjectVal(KEYTYPEID, appInfo, false);
    }

    getAppInfo(gcid, uid, appInfo)
    {
        const KEYTYPEID = "msa~" + gcid + "~" + uid + "~appinfo";
        return this.getObjectVal(KEYTYPEID, false);
    }

}